// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","223":"commons","245":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"70":"fc2049916de5fe20b313","125":"c17ad437104ff108b260","223":"815cc9914a2ca65527fc","242":"0217047e6fff17831f45","245":"28bcfa8cbaa5cba58cf9","556":"15932b040ef92b05468f"}[chunkId] + ".js";
};